import React from 'react';

const JWTContext = React.createContext({
    jwt: '',
    setJwt: (jwt) => { }
})

export default JWTContext